// removed by extract-text-webpack-plugin
module.exports = {"customModalClass":"styles__customModalClass___3tWtg","detailsClass":"styles__detailsClass___18ZLP"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/NewInterfaceOnline/components/ProtocolDetailsModal/styles.css
// module id = 2871
// module chunks = 0